import { GlobalModulesHandler } from './global-modules';
import { SliderWithImages } from './components/slider-with-images';
import { StoreLocator } from './components/store-locator';
import { ClipboardCopy } from './components/clipboard-copy';
import { StoriesWidgetRelated } from './components/stories-widget-related';
import { StoriesList } from './components/stories-list';
import { StoriesWidget } from './components/stories-widget';
import { ProductLineSlider } from './components/product-line-slider';
import { FormGenerator } from './components/form-generator';
import { AmbassadorDetails } from './components/ambassador-details';
import { AmbassadorsList } from './components/ambassadors-list';
import { TeaserListSlider } from './components/teaser-list';
import { AmbassadorsSliderWidget } from './components/ambassadors-slider-widget';
import { Accordion } from './components/accordion';
import { VideoWithLogo } from './components/video-with-logo';
import { HeroSlider } from './components/hero-slider';
import { Modal } from './components/modal';
import { VideoAndDescription } from './components/video-and-description';
import { NavigationGruppo } from './components/navigation-gruppo';
import { HeroMain } from './components/hero-main';
import { ProductCategory } from './components/product-category';
import { ProductsWidgetRelated } from './components/products-widget-related';
import { NavigationBrand } from './components/navigation-brand';
import { ProductList } from './components/product-list';

/**
 * Main App bundle
 *
 * a) If you want to add a short oneliner - you need GlobalModulesHandler
 *
 * b) If you want to add a component with advanced logic - add it's Class with css selector in componentsList
 *    component should implement init() and loading() methods. Use component-a as a reference.
 *    You can use dynamic imports here `await import('...')`
 */

class App {
  constructor () {
    this.globalModulesHandler = new GlobalModulesHandler();
    this.componentsList = [
      ['.slider-with-images', SliderWithImages],
      ['.store-locator', StoreLocator],
      ['.clipboard-copy', ClipboardCopy],
      ['.stories-list', StoriesList],
      ['.stories-widget', StoriesWidget],
      ['.stories-widget-related', StoriesWidgetRelated],
      ['.product-line-slider', ProductLineSlider],
      ['[data-form]', FormGenerator],
      ['.ambassador-details', AmbassadorDetails],
      ['.ambassadors-list', AmbassadorsList],
      ['.teaser-list', TeaserListSlider],
      ['.ambassadors-slider-widget', AmbassadorsSliderWidget],
      ['.accordion-section', Accordion],
      ['.video-with-logo', VideoWithLogo],
      ['.hero-slider', HeroSlider],
      ['.modal', Modal],
      ['.video-and-description', VideoAndDescription],
      ['.navigation-gruppo', NavigationGruppo],
      ['.navigation-brand', NavigationBrand],
      ['.hero-main', HeroMain],
      ['.product-category', ProductCategory],
      ['.products-widget-related', ProductsWidgetRelated],
      ['.product-list-section', ProductList]
    ];
  }

  init() {
    // eslint-disable-next-line
    window.__webpack_public_path__ = `${CMS.contextPath}/.resources/selleria-module/webresources/dist/`;

    this.globalModulesHandler.init();
    this.componentsList.forEach(([selector, Class]) =>
      this.instantiateAndInit(selector, Class)
    );
  }

  instantiateAndInit(selector, Class) {
    const targets = document.querySelectorAll(selector);
    const instances = [];

    if (!targets) {
      return;
    }

    targets.forEach((el) => {
      const component = new Class(el);

      component.loading();
      instances.push(component);
    });

    instances.forEach((component) => {
      setTimeout(() => component.init());
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const app = new App();

  app.init();
});
